module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "button is-primary is-pulled-right",
    attrs: {
      "to": {
        name: 'product-create'
      }
    }
  }, [_vm._v("\n    Add product\n  ")]), _vm._v(" "), _c('data-table', {
    attrs: {
      "data-set": _vm.sortedProducts,
      "page-length": 250,
      "columns": [{
          name: 'i',
          type: 'text',
          prop: 'sku',
          searchable: false
        },
        {
          name: 'SKU',
          type: 'text',
          prop: 'sku'
        },
        {
          name: 'Name',
          type: 'text',
          prop: 'name'
        },
        {
          name: 'COM',
          type: 'text',
          prop: 'company'
        },
        {
          name: 'Price',
          type: 'number',
          prop: 'price'
        },
        {
          name: 'Shipping',
          type: 'number',
          prop: 'shipping'
        },
        {
          name: 'Ship Months',
          sort: false,
          type: 'text',
          prop: 'ship_months'
        },
        {
          name: 'Active',
          type: 'text',
          prop: 'listed'
        },
        {
          name: 'Updated',
          type: 'text',
          prop: 'updated_at'
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_i",
      fn: function(props) {
        return [_c('div', {
          staticClass: "data-images"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'product',
              params: {
                id: props.row.id
              }
            },
            "tabindex": "-1"
          }
        }, _vm._l((props.row.images), function(image) {
          return _c('img', {
            staticClass: "data-image",
            attrs: {
              "src": image.thumbnail_path
            }
          })
        }), 0)], 1)]
      }
    }, {
      key: "column_Name",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'product',
              params: {
                id: props.row.id
              }
            },
            "tabindex": "-1"
          }
        }, [_vm._v("\n        " + _vm._s(_vm._f("limit")(props.row.short_name, 40)) + "\n      ")])]
      }
    }, {
      key: "column_Price",
      fn: function(props) {
        return [_c('div', {
          staticClass: "has-text-right"
        }, [_vm._v("\n        $"), _c('input', {
          staticClass: "input incognito-input auto-size-input",
          attrs: {
            "type": "text",
            "id": 'plist_price_pid_' + props.row.id
          },
          domProps: {
            "value": props.row.price
          }
        })])]
      }
    }, {
      key: "column_Shipping",
      fn: function(props) {
        return [(props.row.shipping == null) ? _c('div', {
          staticClass: "has-text-right"
        }, [_c('small', [_c('em', [_vm._v("OVERRIDDEN")])])]) : _c('div', {
          staticClass: "has-text-right text-nowrap"
        }, [_vm._v("\n        $"), _c('input', {
          staticClass: "input incognito-input auto-size-input",
          attrs: {
            "type": "text",
            "id": 'plist_shipping_pid_' + props.row.id
          },
          domProps: {
            "value": props.row.shipping
          }
        })])]
      }
    }, {
      key: "column_Ship Months",
      fn: function(props) {
        return [(props.row.ship_months == null) ? _c('div', {
          staticClass: "has-text-centered"
        }, [_vm._v("\n        WARNING\n      ")]) : _c('div', {
          staticClass: "ship_month_indicator"
        }, _vm._l((_vm.expandMonths(props.row.ship_months)), function(month) {
          return _c('div', {
            class: {
              'ship_month_display': true, 'ship_month_active': month.active
            },
            on: {
              "click": function($event) {
                return _vm.toggleShipMonth(props.row, month)
              }
            }
          }, [_vm._v("\n          " + _vm._s(month.initial) + "\n        ")])
        }), 0)]
      }
    }, {
      key: "column_Active",
      fn: function(props) {
        return [_c('label', {
          staticClass: "checkbox",
          on: {
            "click": function($event) {
              return _vm.toggleActiveProduct(props.row)
            }
          }
        }, [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": props.row.listed
          }
        })])]
      }
    }, {
      key: "column_Updated",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(_vm._f("moment")(props.row.updated_at, 'from')) + "\n    ")]
      }
    }, {
      key: "controls",
      fn: function(props) {
        return [_c('td', [_c('div', {
          staticClass: "has-text-right"
        }, [_c('a', {
          staticClass: "delete",
          on: {
            "click": function($event) {
              return _vm.deleteProduct(props.row)
            }
          }
        })])])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-right"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        return _vm.updatePrices()
      }
    }
  }, [_vm._v("\n      Update Prices\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65ee5a9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/products/ProductList.vue
// module id = 546
// module chunks = 0